module.exports = __webpack_public_path__ + "static/img/bskd.307c245.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bskd.jpg
// module id = ZOxp
// module chunks = 2